import { Platform } from 'react-native'
import { File, Directory, Paths } from 'expo-file-system'
import { MD5 } from 'crypto-js'

const cache = async (local: File, cache: File) => {
  try {
    if (!local.exists) {
      console.warn('Local file does not exist', local)
      return
    }

    local.copy(cache)
  } catch (e) {
    console.warn('Error caching image', e)
  }
}

export const cacheImage = async (local: string, remote: string) => {
  try {
    const localFile = new File(local)
    if (!localFile.exists) {
      console.warn('Local file does not exist', local)
      return
    }

    // TODO: Android support
    const directory = Platform.select({
      ios: new Directory(Paths.cache, 'com.hackemist.SDImageCache', 'default'),
      default: null,
    })
    if (!directory || !directory.exists) {
      return
    }

    // Only jpg supported for now
    const cacheFile = new File(directory, MD5(remote) + '.jpg')

    cache(localFile, cacheFile)
  } catch (e) {
    console.warn('Error caching image', e)
  }
}

export const cacheAudio = async (local: string, remote: string) => {
  try {
    const localFile = new File(local)
    if (!localFile.exists) {
      console.warn('Local file does not exist', local)
      return
    }

    const cacheFile = new File(Paths.cache, 'ExponentAsset-' + MD5(remote) + localFile.extension)

    cache(localFile, cacheFile)
  } catch (e) {
    console.warn('Error caching audio', e)
  }
}
